module.exports = __webpack_public_path__ + "static/media/finished-ipad-img1.17258701.png";